var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-group city-form-group input-group",
      attrs: { id: "identify-layer-select" },
    },
    [
      _c(
        "MaterialSelect",
        {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
          ],
          staticClass: "city-form-group city-bg",
          attrs: {
            disabled: _vm.disabledSelector,
            id: "input-layer-index",
            name: "layer-index",
            noWrap: false,
            clearable: false,
            filterable: true,
            options: _vm.options,
            value: _vm.optionValue,
            initialData: _vm.optionInitialData,
            inputClasses: [{ "is-invalid": _vm.fnHasError("layer-index") }],
            error: _vm.fnFirstError("layer-index"),
          },
          on: { input: _vm.onChangeIndex },
        },
        [_vm._v("\n        " + _vm._s(_vm.layerPlaceholder) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }